<template>
  <div>
  <div style="height: 20px;"></div>
  <div class="container">
    <!-- Messages -->
    <div id="message">
      <div v-if="message" class="alert alert-info" role="alert">{{ message }}</div>
      <div v-if="uploadMessage" class="alert alert-info" role="alert">{{ uploadMessage }}</div>
      <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>
    </div>

    <div id="form">
      <div class="container_file row">
        <div class="col justify-content-between">
          <TextInput @childEvent="(eventData) => { this.text = eventData }"></TextInput>
        </div>

        <div class="col">
          <label>{{ $t('message.fontFile') }}:</label>
          <div class="d-flex flex-row justify-content-between">
            <div class="font-selection">
              <button @click="triggerFontFileInput">{{ $t('message.chooseFile') }}</button>
              <input type="file" ref="fontFileInput" @change="onFontChange" style="display: none;" accept=".ttf,.otf,.woff2" />
            </div>
            <select v-model="selectedOption" class="styled-select" style="width: 60%;">
              <option v-for="option in fontOptions" :value="option.value" :key="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>

          <div class="image-container">
            <label>{{ $t('message.backgroundImageFile') }}:</label>
            <div class="button-container">
              <button @click="triggerImageFileInput" :class="{ 'button-disabled': isDimensionSpecified }"
                :title="isDimensionSpecified ? $t('message.widthAndHeightSpecified') : ''">
                {{ $t('message.chooseFile') }}
                <div>
                  <div v-if="selectedImageFileName" class="clear-button" @click.stop="clearImage">
                    <div class="clear-button-line"></div>
                    <div class="clear-button-line"></div>
                  </div>
                </div>
              </button>
              <span class="border p-2 fs-6 text-primary nowrap" v-if="selectedImageFileName">{{ selectedImageFileName }}</span>
              <input type="file" ref="imageFileInput" @change="onBackgroundImageChange" style="display: none;" accept="image/*" />
              <div v-if="isLoading" class="loader">{{ $t('message.loading') }}...</div>
            </div>
          </div>
        </div>
      </div>

      <div class="label-container">
        <label>{{ $t('message.width') }}:
          <input type="number" v-model="width" :disabled="isBackgroundImageSpecified"
            :title="isBackgroundImageSpecified ? $t('message.backgroundImageSpecified') : ''" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.height') }}:
          <input type="number" v-model="height" :disabled="isBackgroundImageSpecified"
            :title="isBackgroundImageSpecified ? $t('message.backgroundImageSpecified') : ''" />
        </label>
        <button type="button" class="close" aria-label="Close" @click="clearDimensions">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <input class="optionUnderline" type="checkbox" id="optionUnderline" v-model="isUnderlined">
      <label for="optionUnderline" style="margin-right: 0px;">增加下划线</label>

      <input class="optionEnglishSpacing" type="checkbox" id="optionEnglishSpacing" v-model="enableEnglishSpacing">
      <label for="optionEnglishSpacing" style="margin-right: 0px;">{{ $t('message.enableEnglishSpacing') }}</label>

      <div class="label-container">
        <label>{{ $t('message.fontSize') }}:
          <input type="number" v-model="fontSize" placeholder="recommend > 100" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.lineSpacing') }}:
          <input type="number" v-model="lineSpacing" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.topMargin') }}:
          <input type="number" v-model="marginTop" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.bottomMargin') }}:
          <input type="number" v-model="marginBottom" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.leftMargin') }}:
          <input type="number" v-model="marginLeft" />
        </label>
      </div>

      <div class="label-container">
        <label>{{ $t('message.rightMargin') }}:
          <input type="number" v-model="marginRight" />
        </label>
      </div>

      <button class="btn btn-primary" type="button" @click="toggleCollapse" style="width: 100px; font-size:0.9rem">
        {{ $t('message.expand') }}
      </button>

      <div v-if="isExpanded" id="collapseContent">
        <div class="card card-body">
          <div class="label-container">
            <label>{{ $t('message.lineSpacingSigma') }}:
              <input type="number" v-model="lineSpacingSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.fontSizeSigma') }}:
              <input type="number" v-model="fontSizeSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.wordSpacingSigma') }}:
              <input type="number" v-model="wordSpacingSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.perturbXSigma') }}:
              <input type="number" v-model="perturbXSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.perturbYSigma') }}:
              <input type="number" v-model="perturbYSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.perturbThetaSigma') }}:
              <input type="number" v-model="perturbThetaSigma" step="0.01" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.wordSpacing') }}:
              <input type="number" v-model="wordSpacing" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.strikethrough_probability') }}:
              <input type="number" v-model="strikethroughProbability" step="0.001" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.strikethrough_length_sigma') }}:
              <input type="number" v-model="strikethroughLengthSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.strikethrough_angle_sigma') }}:
              <input type="number" v-model="strikethroughAngleSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.strikethrough_width_sigma') }}:
              <input type="number" v-model="strikethroughWidthSigma" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.strikethrough_width') }}:
              <input type="number" v-model="strikethroughWidth" />
            </label>
          </div>
          <div class="label-container">
            <label>{{ $t('message.ink_depth_sigma') }}:
              <input type="number" v-model="inkDepthSigma" />
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Generation status -->
    <div v-if="isGenerating" class="generation-status">
      <div class="status-generating">🔄 正在生成中，请稍候...</div>
    </div>

    <div class="buttons">
      <button @click="loadPreset">{{ $t('message.loadSettings') }}</button>
      <button @click="savePreset">{{ $t('message.saveSettings') }}</button>
      <button @click="resetSettings">{{ $t('message.resetSettings') }}</button>
      <button @click="generateHandwriting(true)" :disabled="isGenerating">
        {{ isGenerating ? '生成中...' : $t('message.preview') }}
      </button>
      <button @click="generateHandwriting(false)" :disabled="isGenerating">
        {{ isGenerating ? '生成中...' : $t('message.generateFullHandwritingImage') }}
      </button>
      <button @click="generatePDF" :disabled="isGenerating">
        {{ isGenerating ? '生成中...' : $t('message.generatePdf') }}
      </button>
    </div>

    <!-- Page estimate -->
    <div v-if="text && text.length > 0" class="page-info-alert">
      <div class="alert alert-secondary" style="margin: 10px 0; font-size: 14px;">
        📄 预计生成 <strong>{{ estimatePageCount() }}</strong> 页
      </div>
    </div>

    <!-- Preview -->
    <div class="preview">
      <h2 v-if="!previewImages || previewImages.length === 0">{{ $t('message.preview') }}:</h2>
      <div class="preview-container text-center">
        <div v-if="previewImages && previewImages.length > 1" class="mb-3 d-flex justify-content-center align-items-center gap-3">
          <button @click="prevPage" class="btn btn-outline-primary btn-sm" :disabled="currentPreviewIndex === 0">
            &larr; 上一页
          </button>
          <span class="mx-3 font-weight-bold">
            第 {{ currentPreviewIndex + 1 }} 页 / 共 {{ previewImages.length }} 页
          </span>
          <button @click="nextPage" class="btn btn-outline-primary btn-sm" :disabled="currentPreviewIndex === previewImages.length - 1">
            下一页 &rarr;
          </button>
        </div>
        <div v-if="previewImages && previewImages.length > 0">
          <img :src="previewImages[currentPreviewIndex]"
               :alt="$t('message.previewImage') + ' ' + (currentPreviewIndex + 1)"
               style="max-width: 100%; max-height: 70vh; border: 1px solid #ddd; padding: 5px; border-radius: 4px;" />
        </div>
        <img v-else :src="previewImage" :alt="$t('message.previewImage')" style="max-width: 100%; max-height: 70vh;" />
      </div>
    </div>

    <footer class="footer mt-auto py-3 bg-white">
      <div class="container text-center">
        <span class="text-black">{{ $t('message.projectAddress') }}:</span>
        <a href="https://github.com/14790897/handwriting-web" class="text-info">GitHub</a>
        |
        <router-link to="/Introduce" class="text-info">{{ $t('message.introduce') }}</router-link>
      </div>
      <div class="freeprompt">{{ $t('message.freeprompt') }}</div>
    </footer>
  </div>
  </div>
</template>

<script>
import TextInput from './TextInput.vue';
import Swal from 'sweetalert2';
import {
  generateHandwriting as engineGenerate,
  exportPDF,
  canvasToDataURL,
  detectImageMargins,
  getBundledFonts,
  loadUploadedFont,
  estimatePages,
} from '@/engine/index.js';

export default {
  components: {
    TextInput,
  },

  data() {
    return {
      text: '',
      fontFile: null,
      backgroundImage: null,
      backgroundImageFile: null,
      fontSize: 124,
      lineSpacing: 200,
      width: 2481,
      height: 3507,
      marginTop: 50,
      marginBottom: 50,
      marginLeft: 50,
      marginRight: 50,
      previewImage: '/default1.webp',
      previewImages: [],
      currentPreviewIndex: 0,
      lineSpacingSigma: 0,
      fontSizeSigma: 2,
      wordSpacingSigma: 2,
      perturbXSigma: 3,
      perturbYSigma: 3,
      perturbThetaSigma: 0.05,
      wordSpacing: 1,
      errorMessage: '',
      message: '',
      uploadMessage: '',
      selectedFontFileName: '',
      selectedImageFileName: '',
      selectedOption: '1',
      fontOptions: [{ value: '1', text: '系统默认字体' }],
      isLoading: false,
      strikethroughLengthSigma: 2,
      strikethroughAngleSigma: 2,
      strikethroughWidthSigma: 2,
      strikethroughProbability: 0.005,
      strikethroughWidth: 8,
      inkDepthSigma: 30,
      isUnderlined: true,
      enableEnglishSpacing: false,
      isExpanded: false,
      isGenerating: false,
      generatedPages: [],
      localStorageItems: [
        'text', 'fontSize', 'lineSpacing', 'width', 'height',
        'marginTop', 'marginBottom', 'marginLeft', 'marginRight',
        'selectedFontFileName', 'selectedOption',
        'lineSpacingSigma', 'fontSizeSigma', 'wordSpacingSigma',
        'perturbXSigma', 'perturbYSigma', 'perturbThetaSigma', 'wordSpacing',
        'strikethroughLengthSigma', 'strikethroughAngleSigma',
        'strikethroughWidthSigma', 'strikethroughProbability',
        'strikethroughWidth', 'inkDepthSigma',
        'isUnderlined', 'enableEnglishSpacing',
      ],
    };
  },

  async created() {
    this.localStorageItems.forEach((item) => {
      const value = localStorage.getItem(item);
      if (value !== null && value !== 'undefined') {
        try {
          this[item] = JSON.parse(value);
        } catch {
          // ignore
        }
      }
    });

    // Load bundled fonts
    try {
      const fonts = await getBundledFonts();
      if (fonts.length > 0) {
        this.fontOptions = [
          { value: '1', text: '系统默认字体' },
          ...fonts.map((f, i) => ({ value: String(i + 2), text: f })),
        ];
      }
    } catch {
      // Use default options
    }
  },

  computed: {
    isDimensionSpecified() {
      return !!(this.width || this.height);
    },
    isBackgroundImageSpecified() {
      return !!this.backgroundImage;
    },
  },

  watch: {
    text: {
      handler(newVal) { localStorage.setItem('text', JSON.stringify(newVal)); },
      deep: true,
    },
    fontSize: {
      handler(newVal) { localStorage.setItem('fontSize', JSON.stringify(newVal)); },
    },
    lineSpacing: {
      handler(newVal) { localStorage.setItem('lineSpacing', JSON.stringify(newVal)); },
    },
    width: {
      handler(newVal) { localStorage.setItem('width', JSON.stringify(newVal)); },
    },
    height: {
      handler(newVal) { localStorage.setItem('height', JSON.stringify(newVal)); },
    },
    marginTop: {
      handler(newVal) { localStorage.setItem('marginTop', JSON.stringify(newVal)); },
    },
    marginBottom: {
      handler(newVal) { localStorage.setItem('marginBottom', JSON.stringify(newVal)); },
    },
    marginLeft: {
      handler(newVal) { localStorage.setItem('marginLeft', JSON.stringify(newVal)); },
    },
    marginRight: {
      handler(newVal) { localStorage.setItem('marginRight', JSON.stringify(newVal)); },
    },
    selectedOption: {
      handler(newVal) { localStorage.setItem('selectedOption', JSON.stringify(newVal)); },
    },
    selectedFontFileName: {
      handler(newVal) { localStorage.setItem('selectedFontFileName', JSON.stringify(newVal)); },
    },
    lineSpacingSigma: {
      handler(newVal) { localStorage.setItem('lineSpacingSigma', JSON.stringify(newVal)); },
    },
    fontSizeSigma: {
      handler(newVal) { localStorage.setItem('fontSizeSigma', JSON.stringify(newVal)); },
    },
    wordSpacingSigma: {
      handler(newVal) { localStorage.setItem('wordSpacingSigma', JSON.stringify(newVal)); },
    },
    perturbXSigma: {
      handler(newVal) { localStorage.setItem('perturbXSigma', JSON.stringify(newVal)); },
    },
    perturbYSigma: {
      handler(newVal) { localStorage.setItem('perturbYSigma', JSON.stringify(newVal)); },
    },
    perturbThetaSigma: {
      handler(newVal) { localStorage.setItem('perturbThetaSigma', JSON.stringify(newVal)); },
    },
    wordSpacing: {
      handler(newVal) { localStorage.setItem('wordSpacing', JSON.stringify(newVal)); },
    },
    strikethroughLengthSigma: {
      handler(newVal) { localStorage.setItem('strikethroughLengthSigma', JSON.stringify(newVal)); },
    },
    strikethroughAngleSigma: {
      handler(newVal) { localStorage.setItem('strikethroughAngleSigma', JSON.stringify(newVal)); },
    },
    strikethroughWidthSigma: {
      handler(newVal) { localStorage.setItem('strikethroughWidthSigma', JSON.stringify(newVal)); },
    },
    strikethroughProbability: {
      handler(newVal) { localStorage.setItem('strikethroughProbability', JSON.stringify(newVal)); },
    },
    strikethroughWidth: {
      handler(newVal) { localStorage.setItem('strikethroughWidth', JSON.stringify(newVal)); },
    },
    inkDepthSigma: {
      handler(newVal) { localStorage.setItem('inkDepthSigma', JSON.stringify(newVal)); },
    },
    isUnderlined: {
      handler(newVal) { localStorage.setItem('isUnderlined', JSON.stringify(newVal)); },
    },
    enableEnglishSpacing: {
      handler(newVal) { localStorage.setItem('enableEnglishSpacing', JSON.stringify(newVal)); },
    },
  },

  methods: {
    prevPage() {
      if (this.currentPreviewIndex > 0) this.currentPreviewIndex--;
    },
    nextPage() {
      if (this.currentPreviewIndex < this.previewImages.length - 1) this.currentPreviewIndex++;
    },
    toggleCollapse() {
      this.isExpanded = !this.isExpanded;
    },

    getTemplate() {
      return {
        width: Number(this.width) || 2481,
        height: Number(this.height) || 3507,
        fontSize: Number(this.fontSize) || 124,
        lineSpacing: Number(this.lineSpacing) || 200,
        marginTop: Number(this.marginTop) || 50,
        marginBottom: Number(this.marginBottom) || 50,
        marginLeft: Number(this.marginLeft) || 50,
        marginRight: Number(this.marginRight) || 50,
        wordSpacing: Number(this.wordSpacing) || 1,
        isUnderlined: this.isUnderlined,
        enableEnglishSpacing: this.enableEnglishSpacing,
        // Perturbations
        lineSpacingSigma: Number(this.lineSpacingSigma) || 0,
        fontSizeSigma: Number(this.fontSizeSigma) || 2,
        wordSpacingSigma: Number(this.wordSpacingSigma) || 2,
        perturbXSigma: Number(this.perturbXSigma) || 3,
        perturbYSigma: Number(this.perturbYSigma) || 3,
        perturbThetaSigma: Number(this.perturbThetaSigma) || 0.05,
        strikethroughProbability: Number(this.strikethroughProbability) || 0.005,
        strikethroughLengthSigma: Number(this.strikethroughLengthSigma) || 2,
        strikethroughAngleSigma: Number(this.strikethroughAngleSigma) || 2,
        strikethroughWidthSigma: Number(this.strikethroughWidthSigma) || 2,
        strikethroughWidth: Number(this.strikethroughWidth) || 8,
        inkDepthSigma: Number(this.inkDepthSigma) || 30,
      };
    },

    async generateHandwriting(preview = false) {
      if (!this.text || this.text.trim().length === 0) {
        this.errorMessage = '请先输入文字内容';
        return;
      }

      if (this.isGenerating) return;
      this.isGenerating = true;
      this.errorMessage = '';
      this.message = '';
      this.uploadMessage = '正在生成手写图像...';

      try {
        const template = this.getTemplate();

        // Set font family from selected option
        if (this.selectedOption !== '1' && this.selectedFontFileName) {
          template.fontFamily = this.selectedFontFileName.replace(/\.(ttf|otf|woff2?)$/i, '');
        }

        const result = await engineGenerate({
          text: this.text,
          template,
          preview,
          fontFile: this.fontFile,
          backgroundImage: this.backgroundImageFile,
          onProgress: ({ message, progress }) => {
            this.uploadMessage = `${message} (${progress}%)`;
          },
        });

        this.generatedPages = result.pages;

        // Convert canvases to data URLs for preview
        this.previewImages = result.pages.map((canvas) => canvasToDataURL(canvas));
        this.currentPreviewIndex = 0;

        if (preview) {
          this.message = '预览已生成';
        } else {
          this.message = `已生成 ${result.totalPages} 页，点击下载按钮保存`;
        }

        this.uploadMessage = '';
      } catch (err) {
        console.error('Generation failed:', err);
        this.errorMessage = '生成失败: ' + (err.message || '未知错误');
        this.uploadMessage = '';
      } finally {
        this.isGenerating = false;
      }
    },

    async generatePDF() {
      if (!this.text || this.text.trim().length === 0) {
        this.errorMessage = '请先输入文字内容';
        return;
      }

      if (this.generatedPages.length === 0) {
        // Generate first
        await this.generateHandwriting(false);
      }

      if (this.generatedPages.length === 0) return;

      try {
        await exportPDF(this.generatedPages, { filename: 'handwrite.pdf' });
        this.message = 'PDF 已下载';
      } catch (err) {
        this.errorMessage = 'PDF 导出失败: ' + (err.message || '未知错误');
      }
    },

    estimatePageCount() {
      if (!this.text) return 0;
      return estimatePages(this.text, this.getTemplate());
    },

    savePreset() {
      try {
        const data = {};
        this.localStorageItems.forEach((item) => {
          data[item] = this[item];
        });
        localStorage.setItem('myPreset', JSON.stringify(data));
        Swal.fire({
          icon: 'success',
          title: '预设设置保存成功！',
          timer: 2000,
          showConfirmButton: false,
        });
      } catch {
        Swal.fire({ icon: 'error', title: '保存预设设置失败' });
      }
    },

    loadPreset() {
      try {
        const dataString = localStorage.getItem('myPreset');
        if (!dataString || dataString === 'undefined') {
          Swal.fire({ icon: 'info', title: '没有找到保存的预设设置' });
          return;
        }
        const data = JSON.parse(dataString);
        Object.keys(data).forEach((item) => {
          this[item] = data[item];
        });
        Swal.fire({
          icon: 'success',
          title: '预设设置加载成功！',
          timer: 2000,
          showConfirmButton: false,
        });
      } catch {
        Swal.fire({ icon: 'error', title: '加载预设设置失败' });
      }
    },

    resetSettings() {
      this.fontFile = null;
      this.backgroundImage = null;
      this.backgroundImageFile = null;
      this.fontSize = 124;
      this.lineSpacing = 200;
      this.width = 2481;
      this.height = 3507;
      this.marginTop = 50;
      this.marginBottom = 50;
      this.marginLeft = 50;
      this.marginRight = 50;
      this.lineSpacingSigma = 0;
      this.fontSizeSigma = 2;
      this.wordSpacingSigma = 2;
      this.perturbXSigma = 3;
      this.perturbYSigma = 3;
      this.perturbThetaSigma = 0.05;
      this.wordSpacing = 1;
      this.strikethroughLengthSigma = 2;
      this.strikethroughAngleSigma = 2;
      this.strikethroughWidthSigma = 2;
      this.strikethroughProbability = 0.005;
      this.strikethroughWidth = 8;
      this.inkDepthSigma = 30;
      this.isUnderlined = true;
      this.enableEnglishSpacing = false;
      this.errorMessage = '';
      this.message = '';
      this.uploadMessage = '';
      this.selectedFontFileName = '';
      this.selectedImageFileName = '';
      this.selectedOption = '1';
      this.previewImage = '/default1.webp';
      this.previewImages = [];
      this.generatedPages = [];
    },

    async onBackgroundImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.selectedImageFileName = file.name;
      this.backgroundImageFile = file;
      this.previewImage = URL.createObjectURL(file);

      const result = await Swal.fire({
        title: '是否自动识别页面的四周边距？',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });

      if (result.isConfirmed) {
        this.isLoading = true;
        try {
          const margins = await detectImageMargins(file);
          this.marginLeft = margins.marginLeft;
          this.marginRight = margins.marginRight;
          this.marginTop = Math.max(0, margins.marginTop - this.lineSpacing);
          this.marginBottom = margins.marginBottom;
          this.lineSpacing = margins.lineSpacing || this.lineSpacing;
          this.message = '背景图片边距已自动识别';
          this.errorMessage = '';
        } catch (err) {
          console.error('Margin detection failed:', err);
          this.errorMessage = '边距识别失败，请手动设置';
        } finally {
          this.isLoading = false;
        }
      }
    },

    onFontChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.selectedFontFileName = file.name;
      this.fontFile = file;

      // Try to load font immediately
      loadUploadedFont(file).then(({ name }) => {
        const newOption = {
          value: String(this.fontOptions.length + 1),
          text: name,
        };
        this.fontOptions.push(newOption);
        this.selectedOption = newOption.value;
      }).catch((err) => {
        console.error('Font loading failed:', err);
        this.errorMessage = '字体加载失败: ' + err.message;
      });
    },

    triggerImageFileInput() {
      if (!this.isDimensionSpecified) {
        this.$refs.imageFileInput.click();
      } else {
        Swal.fire({
          title: '需要先清空宽度高度才能选择图片',
          text: '点击确定清空宽度高度',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: '清空',
          cancelButtonText: '取消',
        }).then((result) => {
          if (result.isConfirmed) {
            this.width = null;
            this.height = null;
            this.$refs.imageFileInput.click();
          }
        });
      }
    },

    triggerFontFileInput() {
      this.$refs.fontFileInput.click();
    },

    clearImage() {
      this.selectedImageFileName = null;
      this.backgroundImage = null;
      this.backgroundImageFile = null;
      this.$refs.imageFileInput.value = null;
    },

    clearDimensions() {
      this.width = null;
      this.height = null;
    },
  },
};
</script>

<style scoped>
.container {
  display: grid;
  grid-template-areas:
    "form image"
    "button image"
    "message image";
  grid-template-columns: 1fr 2fr;
}

#message {
  grid-area: message;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}

#form {
  grid-area: form;
  flex: 1 0 300px;
  max-width: 650px;
  column-count: auto;
  column-width: 200px;
  column-gap: 1em;
  width: 80vw;
  padding: 20px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: auto;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
}

#form label {
  margin-bottom: 10px;
}

#form input,
#form textarea {
  width: 50%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.label-container {
  display: flex;
  align-items: center;
}

.buttons {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.buttons button {
  grid-area: button;
  padding: 10px 16px;
  border-radius: 6px;
  border: none;
  background: var(--vermillion);
  color: white;
  cursor: pointer;
  transition: all 0.25s ease;
  font-weight: bold;
  font-family: var(--font-heading);
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
  outline: none;
  margin-right: 10px;
  margin-top: 10px;
}

.buttons button:last-child {
  margin-right: 0;
}

.buttons button:hover {
  background: var(--vermillion-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.buttons button:active {
  background: #8B0015;
  transform: translateY(0);
}

.buttons button:disabled {
  background: var(--light-ink);
  cursor: not-allowed;
}

.preview {
  padding: 20px;
  box-sizing: border-box;
  grid-area: image;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  min-width: 100px;
  min-height: 200px;
}

.preview img {
  max-width: 100%;
  height: auto;
  object-fit: cover;
  position: sticky;
  top: 0;
}

input[type="number"],
input[type="text"],
input[type="file"] {
  transition: all 0.3s ease;
}

input[type="number"]:hover,
input[type="text"]:hover,
input[type="file"]:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
}

.container_file {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;
  margin: auto;
}

.container_file label {
  font-size: 1.2rem;
  font-weight: 500;
}

.container_file button {
  padding: 10px 5px;
  font-size: 0.9rem;
  color: white;
  background-color: var(--ochre);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 0 auto;
  font-family: var(--font-heading);
}

.container_file button:hover {
  background-color: var(--ink-dark);
}

.container_file button:disabled {
  background-color: var(--light-ink);
}

.container_file span {
  margin-top: 5px;
  font-size: 0.9rem;
  color: #444;
}

.styled-select {
  padding: 10px;
  border: 1px solid var(--light-ink);
  border-radius: 6px;
  color: white;
  background-color: var(--ochre);
  font-size: 1rem;
  font-family: var(--font-body);
  transition: all 0.3s ease-in-out;
}

.styled-select:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
  background-color: var(--ink-dark);
}

.styled-select:focus {
  outline: none;
  border-color: var(--ochre);
}

.button-container {
  display: flex;
  justify-content: space-around;
  position: relative;
}

.clear-button {
  position: relative;
  top: 5px;
  right: 5px;
  width: 12px;
  height: 12px;
  cursor: pointer;
}

.clear-button-line {
  position: absolute;
  left: 1px;
  width: 10px;
  height: 2px;
  background-color: #000;
}

.clear-button-line:first-child {
  top: 5px;
  transform: rotate(45deg);
}

.clear-button-line:last-child {
  top: 5px;
  transform: rotate(-45deg);
}

.font-selection {
  display: flex;
  justify-content: space-around;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.image-container {
  position: relative;
  margin-bottom: 15px;
}

.close {
  border: none !important;
}

.button-disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed !important;
}

.optionUnderline,
.optionEnglishSpacing {
  margin: 0;
  padding: 0;
  width: 10px;
  padding: 0 !important;
  border-radius: 0 !important;
  border: none !important;
  box-shadow: none !important;
  box-sizing: content-box !important;
}

.freeprompt {
  font-size: 0.8rem;
  color: #e70808;
  text-align: center;
  margin-top: 10px;
}

.generation-status {
  margin: 15px 0;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
}

.status-generating {
  background-color: #e3f2fd;
  color: #1976d2;
  border: 1px solid #bbdefb;
}

@media (max-width: 1000px) {
  .container {
    grid-template-areas:
      "form"
      "button"
      "message"
      "image";
    grid-template-columns: 1fr;
  }
  #form,
  .preview {
    flex: 1 0 100%;
  }
}
</style>
